import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["previousPage", "nextPage"];
  connect() {
    this.handleKeydown = this.handleKeydown.bind(this);
    document.addEventListener("keydown", this.handleKeydown);
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleKeydown);
  }

  handleKeydown(event) {
    if (document.querySelector(".fancybox-focus-guard")) return

    if (event.key === "ArrowRight") {
      this.nextPage();
    } else if (event.key === "ArrowLeft") {
      this.previousPage();
    }
  }

  nextPage() {
    if (this.hasNextPageTarget) {
      this.nextPageTarget.click();
    } 
  }

  previousPage() {
    if (this.hasPreviousPageTarget) {
      this.previousPageTarget.click();
    }
  }
}
